<template>
  <v-container>
    <v-card
      class="pa-2"
    >
      <v-form
        ref="form"
        lazy-validation
      >
        <v-text-field
          v-model="form.email"
          label="E-mail"
          required
        ></v-text-field>
<!--
        <v-text-field
          v-model="form.password"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, rules.min]"
          :type="show1 ? 'text' : 'password'"
          label="비밀 번호"
          hint="At least 8 characters"
          counter
          @click:append="show1 = !show1"
        ></v-text-field> -->

        <v-text-field
          v-model="form.company"
          label="업체 명"
          required
        ></v-text-field>

        <v-text-field
          v-model="form.name"
          label="이름"
          required
        ></v-text-field>

        <v-row>
          <v-col
            cols="5"
            md="5"
          >
            <v-text-field
              v-model="form.postcode"
              label="우편번호"
              readonly
              @click="isPostCode = !isPostCode"
            ></v-text-field>
          </v-col>

          <v-col
            cols="7"
            md="7"
          >
            <v-btn
              @click="isPostCode = !isPostCode"
            >
              우편번호/주소 찾기
            </v-btn>
          </v-col>
        </v-row>
        <v-text-field
          v-model="form.address"
          label="주소"
          required
          readonly
          @click="isPostCode = !isPostCode"
        ></v-text-field>

        <v-text-field
          v-model="form.nextAddress"
          label="상세 주소"
          required
        ></v-text-field>

        <v-btn
          color="success"
          class="mr-4"
          @click="updateUser"
        >
          저장
        </v-btn>
      </v-form>
    </v-card>
    <v-bottom-sheet
      v-model="isPostCode"
      inset
    >
      <v-sheet
        class="text-center"
        height="468px"
      >
        <v-card>
          <div class="d-flex flex-no-wrap justify-space-between">
            <vue-daum-postcode @complete="setAddress($event)" />
          </div>
        </v-card>
      </v-sheet>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      isPostCode: false,
      show1: false,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters'
      },
      User: [],
      form: {
        id: '',
        name: '',
        email: '',
        company: '',
        address: '',
        // password: '',
        postcode: '',
        nextAddress: ''
      }
    }
  },

  created () {
    this.subscribe()
  },

  destroyed () {
  },

  mounted () {
  },

  methods: {
    subscribe () {
      var userID = this.$firebase.auth().currentUser.uid

      var fm = this.form

      this.$firebase.database().ref('users/' + userID).once('value').then(function (snapshot) {
        if (snapshot.empty) {
          this.User = []
          return
        }

        fm.id = userID
        fm.name = (snapshot.val() && snapshot.val().displayName) || '승인중'
        fm.email = (snapshot.val() && snapshot.val().email) || ''
        fm.company = (snapshot.val() && snapshot.val().company) || ''
        // fm.password = (snapshot.val() && snapshot.val().password) || ''
        fm.postcode = (snapshot.val() && snapshot.val().postcode) || ''
        fm.address = (snapshot.val() && snapshot.val().address) || ''
        fm.nextAddress = (snapshot.val() && snapshot.val().nextAddress) || ''
      })
    },

    setAddress (data) {
      var fm = this.form

      fm.postcode = data.zonecode
      fm.address = data.roadAddress

      this.isPostCode = false
    },

    updateUser () {
      var userID = this.$firebase.auth().currentUser.uid

      var fm = this.form

      var updateDatas = {}

      updateDatas['users/' + userID + '/company'] = fm.company
      updateDatas['users/' + userID + '/displayName'] = fm.name
      // updateDatas['users/' + userID + '/password'] = fm.password
      updateDatas['users/' + userID + '/postcode'] = fm.postcode
      updateDatas['users/' + userID + '/address'] = fm.address
      updateDatas['users/' + userID + '/nextAddress'] = fm.nextAddress

      this.$firebase.database().ref().update(
        updateDatas,
        function (error) {
          if (error) {
            console.log(error)
          } else {
            console.log('회원 정보 수정 완료')
          }
        }
      )

      // this.$firebase.database().ref('users/' + userID).set({
      //   company: fm.company,
      //   displayName: fm.name,
      //   address: fm.address,
      //   password: fm.password,
      //   postcode: fm.postcode,
      //   nextAddress: fm.nextAddress
      // }, function (error) {
      //   if (error) {
      //     console.log(error)
      //   } else {
      //     console.log('업뎃 완료')
      //   }
      // })
    }
  }
}
</script>
